/* eslint-disable import/no-unassigned-import */
/* eslint-disable no-undef */
/* eslint-disable react/no-deprecated */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals.js';
import './nca-3ds-web-sdk.js';

ReactDOM.render(
	<React.StrictMode>
		<App/>
	</React.StrictMode>,
	document.querySelector('#root'),
);

reportWebVitals();
